import { Spin } from 'antd';
import { Layout, CtaForm } from '../../components';
import { useEffect, useState } from 'react';

const PAID_CUSTOMIZATION_LINK =
	'https://blog.facilitybot.co/blog/knowledge-base/overview/facilitybot-paid-customization-dedicated-development/';

function CannyFeedback() {
	const BoardToken = '16c33eb3-5404-8649-88d7-d2dc7f291360';
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		setIsLoading(true);
		(function (w, d, i, s) {
			function l() {
				if (!d.getElementById(i)) {
					var f = d.getElementsByTagName(s)[0],
						e = d.createElement(s);
					(e.type = 'text/javascript'),
						(e.async = !0),
						(e.src = 'https://canny.io/sdk.js'),
						f.parentNode.insertBefore(e, f);
				}
			}
			if ('function' != typeof w.Canny) {
				var c = function () {
					c.q.push(arguments);
				};
				(c.q = []),
					(w.Canny = c),
					'complete' === d.readyState
						? l()
						: w.attachEvent
						? w.attachEvent('onload', l)
						: w.addEventListener('load', l, !1);
			}
		})(window, document, 'canny-jssdk', 'script');

		Canny('render', {
			boardToken: BoardToken,
			basePath: null, // See step 2
			ssoToken: null, // See step 3,
			theme: 'light', // options: light [default], dark, auto
		});
	}, []);

	useEffect(() => {
		setTimeout(() => {
			setIsLoading(false);
		}, 1100);
	}, []);

	return (
		<div className="canny-widget">
			{isLoading && (
				<div className="spinner">
					<Spin></Spin>
				</div>
			)}
			<div data-canny />
		</div>
	);
}

export default function FeatureRequests() {
	return (
		<Layout pageName="Feature Requests">
			<div className="resource-page resource-page--feature-requests">
				<section className="heading-container">
					<div className="container">
						<div className="heading heading--unset-mw">
							<h1 className="heading__title">Feature requests and feedback</h1>
							<h2 className="heading__desc">
								We believe in continually improving FacilityBot with new features and feature enhancements that delight
								our users. We believe that great products are built with the help and insights of their users. That’s
								why we’ve created this space for you to share your feedback, suggestions, and feature requests.
							</h2>
							<br />
							<h2 className="heading__desc">
								We would appreciate it if you can be as detailed as possible in your description of the change you want.
								Screenshots or better still screen video recordings are tremendously helpful in helping us, and others
								who may want to vote for your request, understand the precise change that you are suggesting.
							</h2>
							<br />
							<h2 className="heading__desc">
								Please upvote features that you like. The FacilityBot takes into consideration multiple factors to
								decide what changes to make, including the number of different client votes that a feature request has.
							</h2>
							<br />
							<h2 className="heading__desc">
								Please note also that FacilityBot is not obligated to act on your feature request. If you really need a
								feature enhancement and are willing to pay for its prioritized development, please see our{' '}
								<a href={PAID_CUSTOMIZATION_LINK} style={{ color: 'var(--primary)' }} target="_blank" rel="noreferrer">
									paid customization process.
								</a>
							</h2>
							<br />
							<h2 className="heading__desc">
								<span className="bolder">Please note that you need to be logged in to create or upvote a request.</span>
							</h2>
						</div>
					</div>
				</section>

				<CannyFeedback />

				<CtaForm />
			</div>
		</Layout>
	);
}
